<div class="bcg">
  <div class="bcg container">
    <div class="d-flex justify-content-between custom-container">
      <nav class="custom-nav">
        <ol class="breadcrumb m-2">
          <li
            class="breadcrumb-item"
            style="cursor: pointer"
            [routerLink]="'/doqfy/dashboard'"
          >
            Dashboard
          </li>
          <li
            class="breadcrumb-item active"
            style="cursor: default"
            aria-current="page"
          >
            Account Settings
          </li>
        </ol>
      </nav>
    </div>

    <div class="page_responsive card mt-3">
      <div class="card-body p-0">

        <!-- Section header -->
        <div class="notif-card-header">
          <div class="notif-header-icon">
            <i class="bx bx-bell"></i>
          </div>
          <div>
            <h3 class="notif-header-title">Notification Settings</h3>
            <p class="notif-header-sub">Manage how your account behaves</p>
          </div>
        </div>

        <!-- Toggle rows -->
        <div class="notif-rows-wrapper">

          <div class="notif-row">
            <div class="notif-row-icon"><i class="bx bx-envelope"></i></div>
            <div class="notif-row-content">
              <span class="notif-label">Email Notification for Order Completion</span>
            </div>
            <label class="round-toggle">
              <input type="checkbox" [checked]="!email_notification_consent" (click)="toggleNotifyStatus()" />
              <span class="round-track"></span>
            </label>
          </div>

          <div class="notif-divider"></div>

          <div class="notif-row">
            <div class="notif-row-icon"><i class="bx bx-hash"></i></div>
            <div class="notif-row-content">
              <span class="notif-label">Manual Entry of Reference Number</span>
            </div>
            <label class="round-toggle">
              <input type="checkbox" [checked]="!reference_id_consent" (click)="toggleRefNumStatus()" />
              <span class="round-track"></span>
            </label>
          </div>

          <div class="notif-divider"></div>

          <div class="notif-row">
            <div class="notif-row-icon"><i class="bx bx-search-alt"></i></div>
            <div class="notif-row-content">
              <span class="notif-label">Review Placed Orders</span>
            </div>
            <label class="round-toggle">
              <input type="checkbox" [checked]="!order_reviewer" (click)="onOrderReviewerClick($event)" />
              <span class="round-track"></span>
            </label>
          </div>

           <div class="notif-divider"></div>

<div class="notif-row">
  <div class="notif-row-icon">
    <i class="bx bx-user-check"></i>
  </div>

  <div class="notif-row-content">
    <span class="notif-label">Auto Approver<span class="pre-procurement">(Pre-Procurement)</span></span>
  </div>

  <label class="round-toggle">
    <input
      type="checkbox"
      [checked]="!auto_approver"
      (click)="toggleAutoApprover()"
    />
    <span class="round-track"></span>
  </label>
</div>


          <div class="notif-divider"></div>

          <div class="notif-row">
            <div class="notif-row-icon"><i class="bx bx-map-pin"></i></div>
            <div class="notif-row-content">
              <span class="notif-label">Geo-Fencing on E-Sign</span>
            </div>
            <label class="round-toggle">
              <input type="checkbox" [checked]="!geo_fencing" (change)="toggleGeoFencing()" />
              <span class="round-track"></span>
            </label>
          </div>

          <div class="notif-divider"></div>

          <div class="notif-row">
            <div class="notif-row-icon"><i class="bx bx-mobile"></i></div>
            <div class="notif-row-content">
              <span class="notif-label">OTP Validation for E-Sign Link</span>
            </div>
            <label class="round-toggle">
              <input type="checkbox" [checked]="!otp_validation" (click)="toggleOtpValidation()" />
              <span class="round-track"></span>
            </label>
          </div>

          <div class="notif-divider"></div>

          <div class="notif-row">
            <div class="notif-row-icon"><i class="bx bx-camera"></i></div>
            <div class="notif-row-content">
              <span class="notif-label">Signatory Image Capture for E-Sign</span>
            </div>
            <label class="round-toggle">
              <input type="checkbox" [checked]="!esign_webcam" (click)="toggleSignatoryImageCapture()" />
              <span class="round-track"></span>
            </label>
          </div>

          <div class="notif-divider"></div>

          <div class="notif-row">
            <div class="notif-row-icon"><i class="bx bx-credit-card"></i></div>
            <div class="notif-row-content">
              <span class="notif-label">Enable Payment</span>
            </div>
            <label class="round-toggle">
              <input type="checkbox" [checked]="!order_payment" (click)="toggleOrderPayment()" />
              <span class="round-track"></span>
            </label>
          </div>
          <div class="notif-divider"></div>
            <div class="notif-row">
              <div class="notif-row-icon"><i class="bx bx-certification"></i></div>
              <div class="notif-row-content">
                <span class="notif-label">Authorised Seal and Sign</span>
              </div>
              <label class="round-toggle">
                <input type="checkbox" [checked]="!is_authorized_signature" (change)="toggleAuthorisedSignature()" />
                <span class="round-track"></span>
              </label>
            </div>

          <ng-container *ngIf="!isClient">

            <div class="notif-divider"></div>

            <div class="notif-row">
              <div class="notif-row-icon"><i class="bx bx-edit-alt"></i></div>
              <div class="notif-row-content">
                <span class="notif-label">Edit EStamp Default Details</span>
              </div>
              <label class="round-toggle">
                <input type="checkbox" [checked]="!estamp_field_editable" (click)="toggleEStampEdit()" />
                <span class="round-track"></span>
              </label>
            </div>

            <div class="notif-divider"></div>

            <div class="notif-row">
              <div class="notif-row-icon"><i class="bx bx-id-card"></i></div>
              <div class="notif-row-content">
                <span class="notif-label">Aadhaar Validation</span>
              </div>
              <label class="round-toggle">
                <input type="checkbox" [checked]="!aadhaar_validation" (change)="toggleAdharValidation()" />
                <span class="round-track"></span>
              </label>
            </div>

            <div class="notif-divider"></div>

            <div class="notif-row">
              <div class="notif-row-icon"><i class="bx bx-pen"></i></div>
              <div class="notif-row-content">
                <span class="notif-label">Electronic Auto Signature</span>
              </div>
              <label class="round-toggle">
                <input type="checkbox" [checked]="!auto_esign" (change)="toggleAutoEsign()" />
                <span class="round-track"></span>
              </label>
            </div>


            <div class="notif-divider"></div>

            <div class="notif-row notif-row--input" appFeatureFlag="aadhaar_name_validation">
              <div class="notif-row-icon"><i class="bx bx-fingerprint"></i></div>
              <div class="notif-row-content">
                <span class="notif-label">Aadhaar Name Match %</span>
              </div>
              <div class="notif-input-group">
                <input
                  type="number"
                  [(ngModel)]="aadhaar_name_match_percentage"
                  max="100" min="1"
                  [readOnly]="!editAadhaarPercentage"
                  [disabled]="!editAadhaarPercentage"
                  class="notif-number-input"
                />
                <i *ngIf="!editAadhaarPercentage" class="bx bx-edit icon-btn" (click)="toggleEditAadhaarPercentage()" pTooltip="Edit" tooltipPosition="top"></i>
                <i *ngIf="editAadhaarPercentage" class="bx bx-save icon-btn" (click)="saveAadhaarPercentage()" pTooltip="Save" tooltipPosition="top"></i>
                <span *ngIf="aadhaar_name_match_percentage === 0" class="notif-error">Minimum value is 1%</span>
              </div>
            </div>

          </ng-container>

          <div class="notif-divider"></div>

          <div class="notif-row notif-row--input">
            <div class="notif-row-icon"><i class="bx bx-link-external"></i></div>
            <div class="notif-row-content">
              <span class="notif-label">Esign Link Validity (in days)</span>
            </div>
            <div class="notif-input-group">
              <input
                type="number"
                [(ngModel)]="esignExpireValidity"
                max="100" min="1"
                [readOnly]="!editEsignExpireValidity"
                [disabled]="!editEsignExpireValidity"
                class="notif-number-input"
              />
              <i *ngIf="!editEsignExpireValidity" class="bx bx-edit icon-btn" (click)="toggleEditEsignValidity()" pTooltip="Edit" tooltipPosition="top"></i>
              <i *ngIf="editEsignExpireValidity" class="bx bx-save icon-btn" (click)="saveEsignValidityExpiry()" pTooltip="Save" tooltipPosition="top"></i>
            </div>
          </div>
<div class="notif-divider"></div>
<div class="notif-row notif-row--input">
  <div class="notif-row-icon">
    <i class="bx bx-package"></i>
 </div>
  <div class="notif-row-content">
    <span class="notif-label">
      Low eStamp Balance Alert (Number of eStamps)
    </span>
  </div>
  
  <div class="notif-input-group">
   <input
  type="number"
  [(ngModel)]="lowEstampBalanceAlert"
  min="0"
  step="1"
  class="notif-number-input"
  (input)="validateBalanceAlert('estamp')"
  [disabled]="!editLowEstampBalance"
/>

<span 
 *ngIf="lowEstampBalanceError"
 class="notif-error">
  Value must be a non-negative whole number
</span>

    <i 
     *ngIf="!editLowEstampBalance"
      class="bx bx-edit icon-btn"
      (click)="toggleEditLowEstampBalance()">
    </i>
    <i 
      *ngIf="editLowEstampBalance"
      class="bx bx-save icon-btn"
      (click)="saveLowEstampBalance()">
    </i>
  </div>
</div>


<div class="notif-divider"></div>

<div class="notif-row notif-row--input">
  <div class="notif-row-icon">
    <i class="bx bx-wallet"></i>
  </div>
  <div class="notif-row-content">
    <span class="notif-label">
      Low Wallet Balance Alert
    </span>
  </div>


<div class="notif-input-group">
<input
  type="number"
  [(ngModel)]="lowWalletBalanceAlert"
  min="0"
  step="1"
  class="notif-number-input"
  (input)="validateBalanceAlert('wallet')"
  [disabled]="!editLowWalletBalance"
/>
<span 
 *ngIf="lowWalletBalanceError"
 class="notif-error">
 Value must be a non-negative whole number
</span>
    <i 
      *ngIf="!editLowWalletBalance"
      class="bx bx-edit icon-btn"
      (click)="toggleEditLowWalletBalance()">
    </i>
    <i 
      *ngIf="editLowWalletBalance"
      class="bx bx-save icon-btn"
      (click)="saveLowWalletBalance()">
    </i>
  </div>
</div>
        </div>
      </div>
    </div>

    <!-- Accordion - Start -->
    <div class="page_responsive card mt-2 mb-2">
      <!-- E-Stamp Settings  - Accordion-->
      <p-accordion
        [styleClass]="'accordion-flush mt-1'"
        id="estampDetailsAccordionNew"
      >
        <p-accordion-panel value="0">
          <p-accordion-header>
            <h2
              class="accordion-header d-flex justify-content-between w-100 align-items-center"
              id="flush-headingOne"
            >
              <button
                class="accordion-button collapsed estamp-header mt-2 mb-2"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapsethree"
                aria-expanded="false"
                aria-controls="flush-collapsethree"
              >
                <span class="title_five">E-Stamp Settings</span>
              </button>
            </h2>
          </p-accordion-header>
          <p-accordion-content>

          <div style="display: flex; justify-content: space-between">
            <p style="font-size: 12px">Enable E-Stamp?</p>
            <div class="toggle-estamp">
              <label class="toggle-switch" style="zoom: 80%">
                <input
                  type="checkbox"
                  [checked]="!estamp_default"
                  (click)="toggleDefaultEstamp()"
                />
                <span class="slider"></span>
                <span class="switch-text">{{
                  estamp_default ? "Yes" : "No"
                }}</span>
              </label>
            </div>
          </div>

          <p-accordion id="flush-collapsethree" class="mt-2 mb-2 m-2">
            <p-accordion-panel value="0">
              <p-accordion-header>E-stamp Details</p-accordion-header>
              <p-accordion-content id="flush-headingOne" id="headingOne">
              <div class="accordion" id="accordionExample">
                <div class="accordion-item">
                  <div
                    id="collapseOne"
                    class="accordion-collapse collapse show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample"
                  >
                    
<div *ngFor="let groupedData of groupedStampData">
  <div *ngFor="let stateGroup of groupedData.stateGroups">
    <div class="estamp-view-card">

      <!-- Meta info: Account / State / Branch / Process By -->
      <div class="estamp-meta-grid">
        <div class="estamp-meta-item">
          <span class="estamp-meta-label">Account</span>
          <span class="estamp-meta-value">{{ groupedData.estamp.estamp_default_fields.account_info.account_name }}</span>
        </div>
        <div class="estamp-meta-item">
          <span class="estamp-meta-label">State</span>
          <span class="estamp-meta-value">{{ stateGroup.state_name }}</span>
        </div>
        <div class="estamp-meta-item">
          <span class="estamp-meta-label">Branch</span>
          <span class="estamp-meta-value">{{ stateGroup.branch_name || '—' }}</span>
        </div>
        <div class="estamp-meta-item">
          <span class="estamp-meta-label">Process By</span>
          <span class="estamp-meta-value">{{ getProcessTypeLabel(groupedData.estamp.estamp_default_fields.process_type) }}</span>
        </div>
      </div>

      <!-- Individual E-Stamp entries -->
      <div *ngFor="let stamp of stateGroup.stamps; let i = index" class="estamp-entry">

        <!-- Entry header: title + edit + delete -->
        <div class="estamp-entry__header">
          <span class="estamp-entry__title">E-Stamp {{ i + 1 }}</span>
          <div class="estamp-entry__actions">
            <button *ngIf="!isClient && !editStampOpen[getEditStampKey(groupedData, stateGroup, stamp)]"
              pButton pRipple type="button" icon="pi pi-pencil"
              class="p-button-sm p-button-text estamp-edit-btn"
              (click)="openEditStamp(groupedData, stateGroup, stamp)"
              pTooltip="Edit E-Stamp" tooltipPosition="top">
            </button>
            <button *ngIf="!isClient"
              pButton pRipple type="button" icon="pi pi-trash"
              class="p-button-sm p-button-text estamp-delete-btn"
              (click)="removeEstampValues(stamp)"
              pTooltip="Delete E-Stamp" tooltipPosition="top">
            </button>
          </div>
        </div>

        <!-- Read-only fields -->
        <div class="estamp-fields-grid"
          *ngIf="!editStampOpen[getEditStampKey(groupedData, stateGroup, stamp)]">
          <div class="estamp-field">
            <span class="estamp-field__label">First Party Name</span>
            <span class="estamp-field__value">{{ groupedData.estamp.estamp_default_fields.first_party_name || '—' }}</span>
          </div>
          <div class="estamp-field">
            <span class="estamp-field__label">Second Party Name</span>
            <span class="estamp-field__value">{{ groupedData.estamp.estamp_default_fields.second_party_name || '—' }}</span>
          </div>
          <div class="estamp-field">
            <span class="estamp-field__label">Stamp Duty Paid By</span>
            <span class="estamp-field__value">{{ groupedData.estamp.estamp_default_fields.stamp_duty_paid_by || '—' }}</span>
          </div>
          <div class="estamp-field">
            <span class="estamp-field__label">Purpose</span>
            <span class="estamp-field__value">{{ stamp.description || '—' }}</span>
          </div>
          <div class="estamp-field">
            <span class="estamp-field__label">Article Number</span>
            <span class="estamp-field__value">{{ stamp.article_code || '—' }}</span>
          </div>
          <div class="estamp-field">
            <span class="estamp-field__label">Consideration Amount</span>
            <span class="estamp-field__value">{{ stamp.consideration_amount || '—' }}</span>
          </div>
          <div class="estamp-field">
            <span class="estamp-field__label">Stamp Duty Amount</span>
            <span class="estamp-field__value">{{ stamp.stamp_duty_amounts[0] || '—' }}</span>
          </div>
        </div>

        <!-- Inline edit form -->
        <ng-container *ngIf="editStampOpen[getEditStampKey(groupedData, stateGroup, stamp)]">
          <ng-container *ngIf="getEditStampKey(groupedData, stateGroup, stamp) as eKey">
            <div class="estamp-stamp-grid">
              <div class="estamp-form-field">
                <label class="estamp-form-field__label">First Party Name</label>
                <input class="form-control estamp-input"
                  [(ngModel)]="editStampModels[eKey].first_party_name"
                  [ngModelOptions]="{ standalone: true }"
                  placeholder="First party name" maxlength="50" pInputText type="text" />
              </div>

              <div class="estamp-form-field">
                <label class="estamp-form-field__label">Second Party Name</label>
                <input class="form-control estamp-input"
                  [(ngModel)]="editStampModels[eKey].second_party_name"
                  [ngModelOptions]="{ standalone: true }"
                  placeholder="Second party name" maxlength="50" pInputText type="text" />
              </div>

              <div class="estamp-form-field">
                <label class="estamp-form-field__label">Stamp Duty Paid By</label>
                <app-dropdown class="custom-dropdown"
                  [options]="stampDutyPaidByOptions"
                  [(ngModel)]="editStampModels[eKey].stamp_duty_paid_by"
                  [ngModelOptions]="{ standalone: true }"
                  placeholder="Paid By" [filter]="true" filterBy="name"
                  optionValue="code" optionLabel="name" appendTo="body">
                </app-dropdown>
              </div>

              <div class="estamp-form-field">
                <label class="estamp-form-field__label">Purpose</label>
                <input class="form-control estamp-input"
                  [(ngModel)]="editStampModels[eKey].description"
                  [ngModelOptions]="{ standalone: true }"
                  placeholder="Description" maxlength="50" pInputText type="text" />
              </div>

              <div class="estamp-form-field">
                <label class="estamp-form-field__label">Article</label>
                <app-dropdown class="custom-dropdown article-dropdown"
                  [options]="addStampArticles[getStampGroupKey(groupedData, stateGroup)] || []"
                  [(ngModel)]="editStampModels[eKey].article_id"
                  [ngModelOptions]="{ standalone: true }"
                  placeholder="Select Article"
                  [filter]="true" filterBy="articleDisplay" optionValue="id"
                  optionLabel="articleDisplay" appendTo="body">
                </app-dropdown>
              </div>

              <div class="estamp-form-field">
                <label class="estamp-form-field__label">Consideration Amount</label>
                <input class="form-control estamp-input"
                  [(ngModel)]="editStampModels[eKey].consideration_amount"
                  [ngModelOptions]="{ standalone: true }"
                  placeholder="Consideration Amount" pInputText type="number"
                  (keypress)="onNumberKeyPress($event)" (paste)="onNumberPaste($event)" />
              </div>

              <div class="estamp-form-field">
                <label class="estamp-form-field__label">Stamp Duty</label>
                <input class="form-control estamp-input"
                  [(ngModel)]="editStampModels[eKey].stamp_duty_amounts"
                  [ngModelOptions]="{ standalone: true }"
                  placeholder="Stamp Duty Amount" pInputText type="number" />
              </div>
            </div>

            <!-- Save / Cancel -->
            <div class="estamp-add-stamp__actions">
              <p-button label="Save"
                [disabled]="!!editStampSaving[eKey]"
                (onClick)="saveEditStamp(groupedData, stateGroup, stamp)"
                icon="pi pi-check" styleClass="p-button-sm">
              </p-button>
              <p-button label="Cancel"
                (onClick)="cancelEditStamp(groupedData, stateGroup, stamp)"
                styleClass="p-button-sm p-button-outlined">
              </p-button>
            </div>
          </ng-container>
        </ng-container>

      </div>

          <!-- Inline "Add Stamp" form + trigger for this state/branch group -->
          <ng-container *ngIf="!isClient">
            <div *ngIf="addStampFormOpen[getStampGroupKey(groupedData, stateGroup)]; else addStampTrigger"
              class="estamp-stamp-entry estamp-add-stamp">
              <ng-container *ngIf="getStampGroupKey(groupedData, stateGroup) as gKey">
                <!-- Stamp entry header -->
                <div class="estamp-stamp-entry__header">
                  <span class="estamp-stamp-entry__title">
                    E-Stamp {{ (stateGroup.stamps?.length || 0) + 1 }}
                  </span>
                  <button pButton pRipple type="button" icon="pi pi-times"
                    class="p-button-sm p-button-text estamp-delete-btn"
                    (click)="cancelAddStamp(groupedData, stateGroup)"
                    pTooltip="Cancel" tooltipPosition="top">
                  </button>
                </div>

                <!-- New stamp fields -->
                <div class="estamp-stamp-grid">
                  <div class="estamp-form-field">
                    <label class="estamp-form-field__label">First Party Name</label>
                    <input class="form-control estamp-input"
                      [(ngModel)]="addStampModels[gKey].first_party_name"
                      [ngModelOptions]="{ standalone: true }"
                      placeholder="First party name" maxlength="50" pInputText type="text" />
                  </div>

                  <div class="estamp-form-field">
                    <label class="estamp-form-field__label">Second Party Name</label>
                    <input class="form-control estamp-input"
                      [(ngModel)]="addStampModels[gKey].second_party_name"
                      [ngModelOptions]="{ standalone: true }"
                      placeholder="Second party name" maxlength="50" pInputText type="text" />
                  </div>

                  <div class="estamp-form-field">
                    <label class="estamp-form-field__label">Stamp Duty Paid By</label>
                    <app-dropdown class="custom-dropdown"
                      [options]="stampDutyPaidByOptions"
                      [(ngModel)]="addStampModels[gKey].stamp_duty_paid_by"
                      [ngModelOptions]="{ standalone: true }"
                      placeholder="Paid By" [filter]="true" filterBy="name"
                      optionValue="code" optionLabel="name" appendTo="body">
                    </app-dropdown>
                  </div>

                        <div class="estamp-form-field">
                          <label class="estamp-form-field__label">Purpose</label>
                          <input class="form-control estamp-input"
                            [(ngModel)]="addStampModels[gKey].description"
                            [ngModelOptions]="{ standalone: true }"
                            placeholder="Description" maxlength="50" pInputText type="text" />
                        </div>

                          <div class="estamp-form-field">
                            <label class="estamp-form-field__label">Article</label>
                            <app-dropdown class="custom-dropdown article-dropdown"
                              [options]="addStampArticles[gKey] || []"
                              [(ngModel)]="addStampModels[gKey].article_id"
                              [ngModelOptions]="{ standalone: true }"
                              placeholder="Select Article"
                              [filter]="true" filterBy="articleDisplay" optionValue="id"
                              optionLabel="articleDisplay" appendTo="body">
                            </app-dropdown>
                          </div>

                              <div class="estamp-form-field">
                                <label class="estamp-form-field__label">Consideration Amount</label>
                                <input class="form-control estamp-input"
                                  [(ngModel)]="addStampModels[gKey].consideration_amount"
                                  [ngModelOptions]="{ standalone: true }"
                                  placeholder="Consideration Amount" pInputText type="number"
                                  (keypress)="onNumberKeyPress($event)" (paste)="onNumberPaste($event)" />
                              </div>

                              <div class="estamp-form-field">
                                <label class="estamp-form-field__label">Stamp Duty</label>
                                <input class="form-control estamp-input"
                                  [(ngModel)]="addStampModels[gKey].stamp_duty_amounts"
                                  [ngModelOptions]="{ standalone: true }"
                                  placeholder="Stamp Duty Amount" pInputText type="number" />
                              </div>
                            </div>

                              <!-- Save / Cancel -->
                              <div class="estamp-add-stamp__actions">
                                <p-button label="Save"
                                  [disabled]="!!addStampSaving[gKey]"
                                  (onClick)="saveAddStamp(groupedData, stateGroup)"
                                  icon="pi pi-check" styleClass="p-button-sm">
                                </p-button>
                                <p-button label="Cancel"
                                  (onClick)="cancelAddStamp(groupedData, stateGroup)"
                                  styleClass="p-button-sm p-button-outlined">
                                </p-button>
                              </div>
                            </ng-container>
                          </div>

                            <!-- Add Stamp trigger -->
                            <ng-template #addStampTrigger>
                              <div class="estamp-stamp-add-row">
                                <p-button label="Add Stamp" (onClick)="openAddStamp(groupedData, stateGroup)"
                                  icon="pi pi-plus-circle" styleClass="p-button-sm-outline">
                                </p-button>
                              </div>
                            </ng-template>
                          </ng-container>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              </p-accordion-content>
            </p-accordion-panel>
          </p-accordion>

          <div *ngIf="!isClient" class="card card_outLine mt-4 mb-4 m-3">
            <div class="card-body">
              <div>
                <form [formGroup]="estampForm">
                  <div formArrayName="estamp_default_fields">
                    <div
                      *ngFor="let field of estampDefaultFields.controls; let i = index"
                      [formGroupName]="i"
                      class="estamp-form-card"
                    >
                      <!-- Card header: title + delete -->
                      <div class="estamp-form-card__header">
                        <span class="estamp-form-card__title">E-Stamp {{ i + 1 }}</span>
                        <button *ngIf="!isClient"
                          pButton pRipple type="button" icon="pi pi-trash"
                          class="p-button-sm p-button-text estamp-delete-btn"
                          (click)="removeEstampDefaultField(i, field, 'api')"
                          pTooltip="Remove E-Stamp" tooltipPosition="top">
                        </button>
                      </div>

                      <!-- Meta dropdowns: Account / State / Branch / Process By -->
                      <div class="estamp-form-meta-grid">
                        <div class="estamp-form-field">
                          <label class="estamp-form-field__label">Account</label>
                          <app-dropdown
                            [options]="accountUserData"
                            class="custom-dropdown"
                            placeholder="Select Account"
                            optionLabel="account_name"
                            [filter]="true"
                            filterBy="account_name"
                            formControlName="account_id"
                            [readonly]="isClient"
                            appendTo="body"
                            (onChange)="onSelectedAccount($event, i, field)"
                            (onClick)="onAccountClick($event, i, field)"
                          ></app-dropdown>
                          <small class="estamp-form-field__error"
                            *ngIf="field.get('account_id').invalid && (field.get('account_id').dirty || field.get('account_id').touched) && field.get('account_id').hasError('required')">
                            Account is required
                          </small>
                        </div>

                        <div class="estamp-form-field">
                          <label class="estamp-form-field__label">State</label>
                          <app-dropdown
                            class="custom-dropdown"
                            [options]="stateDataAccount[i]"
                            formControlName="state_id"
                            placeholder="Select State"
                            [filter]="true"
                            filterBy="state_name"
                            (onChange)="onStateChange($event, i)"
                            [readonly]="isClient"
                            optionLabel="state_name"
                            appendTo="body"
                          ></app-dropdown>
                          <small class="estamp-form-field__error"
                            *ngIf="field.get('state_id').invalid && (field.get('state_id').dirty || field.get('state_id').touched) && field.get('state_id').hasError('required')">
                            State is required
                          </small>
                        </div>

                        <div class="estamp-form-field">
                          <label class="estamp-form-field__label">Branch</label>
                          <app-dropdown
                            class="custom-dropdown"
                            [options]="branchDataAccount[i]"
                            formControlName="branch_id"
                            placeholder="Select Branch"
                            [filter]="true"
                            filterBy="name"
                            (click)="onBranchChange($event, i)"
                            optionValue="id"
                            [readonly]="isClient"
                            optionLabel="name"
                            appendTo="body"
                          ></app-dropdown>
                        </div>

                        <div class="estamp-form-field">
                          <label class="estamp-form-field__label">Process By</label>
                          <app-dropdown
                            class="custom-dropdown"
                            placeholder="Select Process By"
                            optionLabel="label"
                            optionValue="value"
                            [options]="processOptionsAccount[i] || []"
                            formControlName="process_type"
                            appendTo="body"
                          ></app-dropdown>
                          <small class="estamp-form-field__error"
                            *ngIf="field.get('process_type').invalid && (field.get('process_type').dirty || field.get('process_type').touched) && field.get('process_type').hasError('required')">
                            Process By is required
                          </small>
                        </div>
                      </div>

                      <!-- Details accordion -->
                      <p-accordion [styleClass]="'estamp-details-accordion'" id="accordionPanelsStayOpenExample">
                        <p-accordion-panel value="0">
                          <p-accordion-header>
                            <span class="title_five">Details</span>
                          </p-accordion-header>
                          <p-accordion-content>
                            <div formArrayName="estampDetails">
                              <div
                                *ngFor="let est of getEstamps(i).controls; let j = index"
                                [formGroupName]="j"
                                class="estamp-stamp-entry"
                              >
                                <!-- Stamp entry header: label + delete -->
                                <div class="estamp-stamp-entry__header">
                                  <span class="estamp-stamp-entry__title">E-Stamp Details</span>
                                  <button *ngIf="!isClient"
                                    pButton pRipple type="button" icon="pi pi-trash"
                                    class="p-button-sm p-button-text estamp-delete-btn"
                                    (click)="removeEstamp(i, j, est)"
                                    pTooltip="Remove Stamp" tooltipPosition="top">
                                  </button>
                                </div>

                                <!-- Stamp fields -->
                                <div class="estamp-stamp-grid">
                                  <div class="estamp-form-field">
                                    <label class="estamp-form-field__label">First Party Name</label>
                                    <input class="form-control estamp-input" formControlName="first_party_name"
                                      [readOnly]="j != 0 || isClient" (change)="onNameChange(i)"
                                      placeholder="First party name" maxlength="50" pInputText type="text" />
                                    <small class="estamp-form-field__error"
                                      *ngIf="est.get('first_party_name').invalid && (est.get('first_party_name').dirty || est.get('first_party_name').touched) && est.get('first_party_name').hasError('required')">
                                      First Party Name is required
                                    </small>
                                  </div>

                                  <div class="estamp-form-field">
                                    <label class="estamp-form-field__label">Second Party Name</label>
                                    <input class="form-control estamp-input" formControlName="second_party_name"
                                      [readOnly]="j != 0 || isClient" (change)="onNameChange(i)"
                                      placeholder="Second party name" maxlength="50" pInputText type="text" />
                                  </div>

                                  <div class="estamp-form-field">
                                    <label class="estamp-form-field__label">Stamp Duty Paid By</label>
                                    <app-dropdown class="custom-dropdown" [options]="stampDutyPaidByOptions"
                                      [readonly]="j != 0 || isClient" formControlName="stamp_duty_paid_by"
                                      placeholder="Paid By" [filter]="true" filterBy="name"
                                      optionValue="code" (change)="onNameChange(i)" optionLabel="name" appendTo="body">
                                    </app-dropdown>
                                    <small class="estamp-form-field__error"
                                      *ngIf="est.get('stamp_duty_paid_by').invalid && (est.get('stamp_duty_paid_by').dirty || est.get('stamp_duty_paid_by').touched) && est.get('stamp_duty_paid_by').hasError('required')">
                                      Stamp Duty Paid By is required
                                    </small>
                                  </div>

                                  <div class="estamp-form-field">
                                    <label class="estamp-form-field__label">Purpose</label>
                                    <input class="form-control estamp-input" formControlName="description"
                                      placeholder="Description" maxlength="50" pInputText
                                      [readOnly]="isClient" type="text" />
                                    <small class="estamp-form-field__error"
                                      *ngIf="est.get('description').invalid && (est.get('description').dirty || est.get('description').touched) && est.get('description').hasError('required')">
                                      Purpose is required
                                    </small>
                                  </div>

                                  <div class="estamp-form-field">
                                    <label class="estamp-form-field__label">Article</label>
                                    <app-dropdown class="custom-dropdown article-dropdown" [options]="articlesAccount[i]"
                                      formControlName="article_id" placeholder="Select Article"
                                      [filter]="true" filterBy="articleDisplay" optionValue="id"
                                      [readonly]="isClient" (onChange)="onArticleChange($event, i, j)"
                                      optionLabel="articleDisplay" appendTo="body">
                                    </app-dropdown>
                                    <small class="estamp-form-field__error"
                                      *ngIf="est.get('article_id').invalid && (est.get('article_id').dirty || est.get('article_id').touched) && est.get('article_id').hasError('required')">
                                      Article is required
                                    </small>
                                  </div>

                                  <div class="estamp-form-field">
                                    <label class="estamp-form-field__label">Consideration Amount</label>
                                    <input class="form-control estamp-input" formControlName="consideration_amount"
                                      placeholder="Consideration Amount" pInputText [readOnly]="isClient"
                                      type="number" (keypress)="onNumberKeyPress($event)" (paste)="onNumberPaste($event)" />
                                  </div>

                                  <div class="estamp-form-field">
                                    <label class="estamp-form-field__label">Stamp Duty</label>
                                    <input class="form-control estamp-input" formControlName="stamp_duty_amounts"
                                      placeholder="Stamp Duty Amount" pInputText [readOnly]="isClient" type="number" />
                                    <small class="estamp-form-field__error"
                                      *ngIf="est.get('stamp_duty_amounts').invalid && (est.get('stamp_duty_amounts').dirty || est.get('stamp_duty_amounts').touched) && est.get('stamp_duty_amounts').hasError('required')">
                                      Stamp Duty is required
                                    </small>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div *ngIf="!isClient" class="estamp-stamp-add-row">
                              <p-button label="Stamp" (onClick)="addEstamp(i)"
                                icon="pi pi-plus-circle" styleClass="p-button-sm-outline">
                              </p-button>
                            </div>
                          </p-accordion-content>
                        </p-accordion-panel>
                      </p-accordion>
                    </div>
                    <div *ngIf="!isClient" class="mt-3 custom_button">
                      <p-button
                        label="Add E-Stamp"
                        (onClick)="
                          addEstampDefaultField(estampDefaultFields.length)
                        "
                        styleClass="p-button-sm-outline"
                      ></p-button>
                    </div>
                  </div>
                </form>
              </div>
              <div *ngIf="!isClient" class="mt-3 custom_button text-right">
                <p-button
                  label="Save"
                  (onClick)="postDefaultAccountData()"
                  styleClass="p-button-sm-outline"
                ></p-button>
              </div>
            </div>
          </div>
          </p-accordion-content>
        </p-accordion-panel>
      </p-accordion>

      <!-- E-Sign Settings - Accordion -->
      <p-accordion class="mt-2" [multiple]="true" [value]="isEsignTabOpen ? ['esign'] : []" (valueChange)="isEsignTabOpen = $event?.includes('esign')">
        <p-accordion-panel value="esign">
          <p-accordion-header>E-Sign Settings</p-accordion-header>
          <p-accordion-content>
          <div class="card-body">
            <div style="display: flex; justify-content: space-between">
              <p style="font-size: 12px">Enable E-Sign?</p>
              <div class="toggle-estamp">
                <label class="toggle-switch" style="zoom: 80%">
                  <input type="checkbox" [checked]="!esign_default" (click)="toggleDefaultEsign()" />
                  <span class="slider"></span>
                  <span class="switch-text">{{ esign_default ? "Yes" : "No" }}</span>
                </label>
              </div>
            </div>

      <div class="form_outline_sty" *ngFor="let party of eSignParties; let i = index; let isLast = last">
        <br />
        <strong class="m-1 mt-2 title_header_0">Signer {{ i + 1 }}</strong>
        
        <div class="row form_inputFields mb-2 mt-2">
          
          <div class="col-lg-3 col-sm-12 col-md-6 mb-2">
            <span class="form_field">Party Name <span class="text-danger">*</span></span><br />
            <input class="p-2 w-100 mt-1" type="text" pInputText [(ngModel)]="party.party_name" 
                   placeholder="Enter Party Name" (ngModelChange)="onSignChange('ESign')" />
            <div *ngIf="submitted && (!party.party_name || isOnlySpaces(party.party_name))" class="error-message text-danger" style="font-size: 12px;">
              Party Name cannot be blank
            </div>
              </div>

         <div class="col-lg-3 col-sm-12 col-md-6 mb-2">
          <span class="form_field">Party Email <span class="text-danger">*</span></span><br />
    
              <input class="p-2 w-100 mt-1" 
                type="email" 
                pInputText 
                [(ngModel)]="party.party_email" 
                placeholder="Enter Email" 
                (ngModelChange)="onSignChange('ESign')" />
           
              <div *ngIf="submitted && !isEmailValid(party.party_email)" class="error-message text-danger" style="font-size: 12px;">
                  Invalid email format
              </div>
          </div>

          <div class="col-lg-3 col-sm-12 col-md-6 mb-2">
            <span class="form_field">Contact Number</span><br />
            <input class="p-2 w-100 mt-1" type="text" pInputText [(ngModel)]="party.contact_number" 
                   maxlength="10" (keypress)="numberOnly($event)" placeholder="Enter 10 digit number" 
                   (ngModelChange)="onSignChange('ESign')" />
            <div *ngIf="submitted && party.contact_number && party.contact_number.length < 10" class="error-message text-danger" style="font-size: 12px;">
              Must be exactly 10 digits
            </div>
          </div>

          <div *ngIf="eSignParties.length > 1" style="padding-top: 24px; text-align: center" class="col-lg-2 col-sm-2 col-md-2 remove_btn">
            <button pButton pRipple type="button" icon="pi pi-trash" (click)="removeESignParty(i)" class="p-button-sm"></button>
          </div>

        </div>

      <div class="row mb-2">
        <div class="col-lg-3 col-sm-12 col-md-6 mb-2">
         <span class="form_field">Sign Method</span><br />
         <app-dropdown
         [options]="signMethodOptions"
         [(ngModel)]="party.sign_method"
         placeholder="Select Sign Method"
         optionLabel="label"
         optionValue="value"
         styleClass="w-100 mt-1 small-input"
         appendTo="body"
         [sort]="false"
         (ngModelChange)="onSignChange('ESign')">
        </app-dropdown>
      </div>
      <div class="col-lg-3 col-sm-12 col-md-6 mb-2" *ngIf="party.sign_method === 'AADHAAR' && aadhaar_validation">
        <span class="form_field">Enter last 4 digits of Aadhaar</span><br />
        <input type="text" pInputText [(ngModel)]="party.aadhaar_four_digit" class="w-100 mt-1 small-input"
          placeholder="Enter 4 digits" maxlength="4" (keypress)="onlyNumbers($event)"
          (ngModelChange)="onSignChange('ESign')" />
      </div>

        <div class="col-lg-3 col-sm-12 col-md-6 mb-2" *ngIf="party.sign_method === 'AADHAAR'">
         <span class="form_field">Sign Mode</span><br />
         <app-dropdown
          [options]="signModeOptions"
          [(ngModel)]="party.sign_mode"
          placeholder="Select Sign Mode"
          optionLabel="label"
          optionValue="value"
          styleClass="w-100 mt-1 small-input"
          appendTo="body"
          [sort]="false"
          (ngModelChange)="onSignChange('ESign')">
          </app-dropdown>
         </div>
        </div>
       <hr style="margin: 15px 0; border-top: 1px solid rgba(94, 93, 92, 0.726); position: relative;top: 1.7rem;" *ngIf="!isLast" />
      </div>

         <div class="mt-3">
          <p-button icon="pi pi-plus" label="Add E-Sign Party" (click)="addESignParty()" 
                styleClass="p-button-sm-outline"></p-button>
            </div>

          <div class="mt-3 custom_button text-right" style="text-align: right;">
          <p-button label="Save" (click)="postDefaultEsignData()" styleClass="p-button-sm"></p-button>
          </div>

          </div>
          </p-accordion-content>
        </p-accordion-panel>
      </p-accordion>

      <!-- Multifactor Authentication - Accordion -->
      <p-accordion class="mt-2" [multiple]="true">
        <p-accordion-panel value="0">
          <p-accordion-header>Multifactor Authentication</p-accordion-header>
          <p-accordion-content>
          <div>
            <div class="card-body">
              <div style="display: flex; justify-content: space-between">
                <p style="font-size: 12px">
                  Would you like to enable Email OTP login?
                </p>
                <div class="toggle-estamp">
                  <label class="toggle-switch" style="zoom: 80%">
                    <input
                      type="checkbox"
                      [disabled]="isAdmin !== 'ORGANISATION-ADMIN'"
                      [checked]="!authentication_default"
                      (click)="toggleAuthentication()"
                    />
                    <span
                      class="slider"
                      [ngClass]="{
                        'disabled-checkbox': isAdmin !== 'ORGANISATION-ADMIN'
                      }"
                    ></span>
                    <span
                      class="switch-text"
                      [ngClass]="{
                        'disabled-checkbox': isAdmin !== 'ORGANISATION-ADMIN'
                      }"
                      >{{ authentication_default ? "Yes" : "No" }}</span
                    >
                  </label>
                </div>
              </div>
            </div>
          </div>
          </p-accordion-content>
        </p-accordion-panel>
      </p-accordion>

      <!-- Single Sign On - Accordion -->
      <p-accordion
        appFeatureFlag="authorization.sso"
        class="mt-2 mb-4"
        [multiple]="true"
      >
        <p-accordion-panel value="0">
          <p-accordion-header>Single Sign On</p-accordion-header>
          <p-accordion-content>
          <div>
            <div class="card-body">
              <div style="display: flex; justify-content: space-between">
                <p style="font-size: 12px">Enable Microsoft SSO?</p>
                <div class="toggle-estamp">
                  <label class="toggle-switch" style="zoom: 80%">
                    <input
                      type="checkbox"
                      [disabled]="isAdmin !== 'ORGANISATION-ADMIN'"
                      [checked]="!ssoDefault"
                      (click)="toggleDefaultSSO()"
                    />
                    <span
                      class="slider"
                      [ngClass]="{
                        'disabled-checkbox': isAdmin !== 'ORGANISATION-ADMIN'
                      }"
                    ></span>
                    <span
                      class="switch-text"
                      [ngClass]="{
                        'disabled-checkbox': isAdmin !== 'ORGANISATION-ADMIN'
                      }"
                      >{{ ssoDefault ? "Yes" : "No" }}</span
                    >
                  </label>
                </div>
              </div>
              <div *ngIf="ssoDefault">
                <p>Tenant Id:</p>
                <input
                  style="width: 300px"
                  type="text"
                  placeholder="Enter your tenant Id"
                  [readonly]="isReadTenantId"
                  [(ngModel)]="msTenantId"
                />
                <p-button
                  [label]="isReadTenantId ? 'Edit' : 'Update'"
                  class="ms-3"
                  (onClick)="saveTenantId()"
                  styleClass="p-button-sm-outline"
                ></p-button>
              </div>
            </div>
          </div>
          </p-accordion-content>
        </p-accordion-panel>
      </p-accordion>
      <!-- Accordion - End -->
    </div>
  </div>

  <!-- ------------- -->
  <div class="toast_display_layer">
    <p-toast></p-toast>
  </div>

  <p-confirmDialog
    [style]="{ width: '50vw' }"
  ></p-confirmDialog>

  <!-- Small E-Stamp confirm/info dialog (shared party update, duplicate state/branch) -->
  <p-confirmDialog
    key="estampSmallConfirm"
    styleClass="estamp-small-confirm"
    [style]="{ width: '460px', maxWidth: '92vw' }"
    [closable]="false"
  ></p-confirmDialog>
</div>